<div class="db-plan-period-switch" *ngIf="!isApiReseller" [ngClass]="{'for-popup': fromPopup}">
  <div class="db-switch__input" [class.disabled]="disabled" [ngClass]="{'small': small}">

    <!-- Monthly Option -->
    <div class="db-option db-monthly" [class.active]="value === 1" (click)="onSwitch(1)">
      <span class="db-option-text">{{'text_periodMonthly' | dbText}}</span>
    </div>

    <!-- Annual Option -->
    <div class="db-option db-yearly"  [class.active]="value === 12" (click)="onSwitch(12)">
      <span class="db-option-text">{{'text_periodYearly' | dbText}}</span>
    </div>
  </div>

  <!-- Save Offer Text Outside the Switch -->
  <div class="save-offer-text">
    <b>Save up to 50%</b><br class="desktop"/> with Annual
  </div>
</div>

<div class="db-plan-period-switch-api-reseller" *ngIf="isApiReseller" [ngClass]="{'for-popup': fromPopup}">
  <div class="db-switch__input" [class.disabled]="disabled" [ngClass]="{'small': small}">

    <!-- Monthly Option -->
    <div class="db-option db-monthly" [class.active]="value === 1" (click)="onSwitch(1)">
      <span class="db-option-text">{{'text_periodMonthly' | dbText}}</span>
    </div>

    <!-- Annual Option -->
    <div class="db-option db-yearly"  [class.active]="value === 12" (click)="onSwitch(12)">
      <span class="db-option-text">{{'text_periodYearly' | dbText}}</span>
    </div>
  </div>

</div>
